<template>
<div>
	<div v-if="periodView">
	
		<div v-if="selectedPeriod" >

			<div class="d-flex flex-row justify-content-between mb-2">
				<a href="#" v-on:click.prevent="selectedPeriod = false">
					<i class="fa fa-arrow-left"></i>
					Back to Pay Periods
				</a>
				<i class="icon-button fa fa-times" v-on:click="selectedPeriod = false"></i>
			</div>

			<h2>{{payPeriodLabel(selectedPeriod)}}</h2>

			<div style="overflow-x: auto;">
				<table class="table table-sm user-table">
					<period-report-user 
						:user-report="periodReport"
						:period-days="periodDays"
						:user-note="userNote"
						:user-note-toggle="true"
						:colspan="periodDays.length+3"
						:user="$store.employee"
						:readonly="true">		
					</period-report-user>
				</table>
			</div>
		</div>
		
		<table-list v-else
			:loading="periodsLoading"
			:records="mutatedPeriods"
			:fields="[
				{label: 'Pay Period',key: 'label'},
				{label: 'Year',key:'year'}
			]"
			:other-buttons="[
				{
					click: 'viewPeriod',
					icon: 'fa-eye',
					text: 'View',
					class: 'btn-light'
				}
			]"
			id-field="slug"
			:sortable="true"
			record-name="Pay Period"
			:hide-record-count="true"
			:clickable-row="true"
			v-on:edit="openPeriod"
			v-on:viewPeriod="openPeriod">

			<button class="btn btn-light float-right" v-on:click="toggleView">
				<i class="fa fa-list"></i>
				List View
			</button>

			<h2>Pay Periods</h2>

		</table-list>

	</div>

	<div v-else>
		
		<time-log-table
			:heading="'Time Logs for '+$store.employee.first_name+' '+$store.employee.last_name"
			:block-fetches="blockFetches"
			:show-job="true"
			:editable="true"
			:filtering-tools="true"
			:page-num="pageNum"
			:filters="filters"
			:default-filter-values="{dateFrom: defaultDateFromFilter}">

			<button class="btn btn-light float-right" v-on:click="toggleView">
				<i class="fa fa-calendar-alt"></i>
				Period View
			</button>

		</time-log-table>
	</div>

</div>
</template>

<script>
import TimeLogTable from "@/components/super_components/TimeLogTable"
import TimeLogMixins from "@/mixins/TimeLogMixins.js"
import PeriodReportUser from "@/pages/time_logs/PeriodReportUser"
import TableList from "@/components/TableList"

export default {

	name: 'EmployeeTimeLogs',
	components: {
		TimeLogTable,
		PeriodReportUser,
		TableList
	},
	mixins: [TimeLogMixins],
	props: ["blockFetches"],
	data() {
		return {
			periodView: true,
			periodsLoading: false,
			periods: [],
			selectedPeriod: null,
			pageNum: 1,
			initialTimeLogSettings: {}
		}
	},
	watch: {
		'$store.employee'() {
			if (this.periodView)
				this.fetchPeriods()
		}
	},
	computed: {
		mutatedPeriods() {
			let vm = this

			return this.periods.filter(period => period.PayPeriod).map(userPeriod => {
			
				userPeriod.label = vm.payPeriodLabel(userPeriod)
				userPeriod.year = vm.moment(userPeriod.PayPeriod.start).format("YYYY")

				return userPeriod
			})
		},
		filters() {
			return [['user_id',this.$store.employee.id]]
		},
		userNote() {
			return ""
		},
		periodDays() {
			let days = []

			let start = this.moment(this.selectedPeriod.PayPeriod.start)
			let end = this.moment(this.selectedPeriod.PayPeriod.end).add(1,"days")

			let d = start
			while (d < end) {

				days.push(this.moment(d))

				d = new Date(start.add(1,"days"))
			}

			return days
		},
		periodReport() {

			if (!this.selectedPeriod || !("report_json" in this.selectedPeriod))
				return false

			let reportObj = {}
			try {
				reportObj = JSON.parse(this.selectedPeriod.report_json)
			}
			catch (e) {}

			let report = this.mutateReport(reportObj,this.selectedPeriod)

			return report
		}
	},
	methods: {
		payPeriodLabel(period) {
			if (period) {
				let start = this.moment(period.PayPeriod.start).format("MMM D")
				let end = this.moment(period.PayPeriod.end).format("MMM D")

				return start + " to "+ end
			}
			else return ""
		},
		toggleView() {
			if (this.periodView) 
				this.periodView = false
			else {
				this.periodView = true
				this.fetchPeriods()
			}
		},
		openPeriod(record) {
			let vm = this
			this.selectedPeriod = record
			this.fetchCollectiveAgreements()

			this.fetchPeriodUserReport(record.slug).then(response => {
				if (response.success) {
					let period = vm.cloneObj(record.PayPeriod)
					vm.selectedPeriod = response.data
					vm.selectedPeriod.PayPeriod = period
				}
			})
		},
		fetchCollectiveAgreements() {
			let vm = this
			this.getJSON("Union/get",{include:["CollectiveAgreement"]}).then(response => {
				if (response.success) {
					let collectiveAgreements = []
					response.data.forEach(union => {
						if ("CollectiveAgreement" in union && union.CollectiveAgreement.length > 0)
							collectiveAgreements = collectiveAgreements.concat(union.CollectiveAgreement)
					})
					vm.collectiveAgreements = collectiveAgreements
				}
			})
		},
		fetchPeriodUserReport(slug) {
			let vm = this

			this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("PayPeriodUserReport/find/"+slug).then(response => {
					vm.spinner(false)
					resolve(response)
				})
			})
		},
		fetchPeriods() {
			let vm = this

			this.loading = true
			this.spinner(true)

			let filters = this.cloneObj(this.filters)

			filters.push(["PayPeriod.processed",0])

			let params = {
				filters,
				include: [{model:"PayPeriod",fields:["id","slug","start","end","processed"]}],
				orders: [["period_id","DESC"]],
				fields: ["id","slug","period_id","PayPeriod"]
			}

			this.getJSON("PayPeriodUserReport/get",params,true).then(response => {
				vm.spinner(false)
				vm.loading = false

				if (response.success)
					vm.periods = response.data
			})
		}
	},
	created() {
		if (this.$store.userDetails && "CompanySettings" in this.$store.userDetails && this.$store.userDetails.CompanySettings && this.$store.userDetails.CompanySettings.is_salary == 1)
			this.periodView = false
		else
			this.fetchPeriods()

		//period-report-user component needs the timeLogSettings set, and in the employee's view, we need to turn them all one, so save the toggle settings first before we unilaterally change them
		this.initialTimeLogSettings = this.cloneObj(this.$store.timeLogSettings)
		this.$store.timeLogSettings.report_display_job = 1
		this.$store.timeLogSettings.report_display_rate = 1
		this.$store.timeLogSettings.report_display_total = 1
	},
	destroyed() {
		//reset timelogsettings

		this.$store.timeLogSettings = this.initialTimeLogSettings
	}
}
</script>